<template>
    <div class="loader-full-message">
            <div class="loader"></div>
            <div class="loader-message">{{message}}</div>
    </div>
</template>

<script>
export default {
    props:["message"]
}
</script>

<style lang="scss" scoped>
.loader-full-message{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #30353b;
    position: absolute;
    top: 0;
    z-index: 9;

    .loader {
        border: 3px solid #e7fffd;
        border-radius: 50%;
        border-top: 3px solid #3defe4;
        width: 32px;
        height: 32px;
        -webkit-animation: spin .8s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
        margin-right: 10px;
    }
    .loader-message{
        color: #fff;
        letter-spacing: 1px;
        text-transform: lowercase;
        padding: 15px 0 0 0;
    }

    /* Safari */
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

}
@media only screen and (max-width: 750px){
    .loader-full-message{
        height: 100vh;
    }
}
</style>